<div
  [ngClass]="{
    'flex-row-reverse': config?.widget?.legendPosition === 'right',
    'flex-column':
      config?.widget?.legendPosition === 'bottom' ||
      config?.widget?.legendPosition === 'top',
    'flex-column-reverse': config?.widget?.legendPosition === 'bottom',
  }"
  class="flex flex-1 justify-content-between align-items-stretch gap-0">
  @if (!chartData || !chartData.datasets || !chartData.datasets.length) {
    <div
      class="absolute z-3 text-center text-2xl text-color-secondary flex align-items-center justify-content-center h-full w-full gap-3 surface-ground p-5">
      <div class="flex flex-column gap-1">
        <div class="flex gap-3 align-items-center justify-content-center">
          <i class="fa-solid fa-person-digging"></i>
          <i>Keine Daten verfügbar</i>
        </div>
        @if (type === 'scatter') {
          <p-divider />
          <div class="text-base font-light align-items-baseline">
            <i class="fas fa-info-circle mr-1"></i> Wählen Sie
            <b>zwei</b> Indikatoren aus, um ein Streudiagramm zu erstellen.
          </div>
        } @else if (type === 'bubble') {
          <p-divider />
          <div class="text-base font-light align-items-baseline">
            <i class="fas fa-info-circle mr-1"></i> Wählen Sie
            <b>drei</b> Indikatoren aus, um ein Blasendiagramm zu erstellen.
          </div>
        }
      </div>
    </div>
  } @else if (
    displayLegend &&
    type &&
    type !== 'adder' &&
    config &&
    config?.widget?.legendPosition !== 'none'
  ) {
    <app-chart-legend
      [ngClass]="{
        'max-w-12rem':
          config?.widget?.legendPosition === 'right' ||
          config?.widget?.legendPosition === 'left',
      }"
      class="align-self-center word-wrap"
      [type]="type"
      [widgetId]="config._id"
      [initialDisabledDatasets]="config?.widget?.disabledDatasets || []"
      [initialDisabledDataPoints]="config?.widget?.disabledDataPoints || []"
      [legendPosition]="config?.widget?.legendPosition || 'right'"
      [legendGroups]="chartData.legendGroups"
      [dataGroups]="chartData.groups"
      (datasetToggled)="onDatasetToggled($event)"
      (dataPointToggled)="onDataPointToggled($event)"
      [chartInstance]="chartInstance"
      [datasets]="chartData.datasets">
    </app-chart-legend>
  }

  <div class="flex-1 chart-wrapper" #chartComp>
    <canvas #chartCanvas></canvas>
  </div>
</div>
